import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { Community } from '@/models/Search';
import { ChartData } from 'chart.js';
import { color } from 'd3-color';
import Chart from 'primevue/chart';
import { computed, inject, Ref } from 'vue';
import { useStore } from 'vuex';


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const store = useStore();
const clusters = inject('clusters') as Ref<Community[]>;
const clusterColors = inject('clusterColors') as Ref<Record<number, string>>;

const currentNodeType = computed(() => store.getters['search/currentNodeType'] as string);

const clusterDistribution = computed(() =>
  clusters.value.reduce(
    (prev, c) => {
      const labels = prev.labels?.concat(c.displayName);
      const data = prev.datasets[0].data.concat(c.properties.size);
      const backgroundColor = prev.datasets[0].backgroundColor as string[];
      const hoverBackgroundColor = prev.datasets[0].hoverBackgroundColor as string[];
      const clusterColor = clusterColors.value[parseInt(c.id)];
      return {
        labels,
        datasets: [
          {
            ...prev.datasets[0],
            data,
            backgroundColor: backgroundColor.concat(clusterColor),
            hoverBackgroundColor: hoverBackgroundColor.concat(
              color(clusterColor)?.brighter(0.5).formatHex() ?? clusterColor
            ),
          },
        ],
      };
    },
    {
      labels: [],
      datasets: [
        {
          data: [],
          backgroundColor: [] as string[],
          hoverBackgroundColor: [] as string[],
          borderColor: '#D1D5DB',
        },
      ],
    } as ChartData<'doughnut'>
  )
);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(Chart), {
    type: "doughnut",
    data: _unref(clusterDistribution),
    options: {
      plugins: {
        legend: false,
        title: {
          display: true,
          text: 'Distribution of ' + _unref(currentNodeType),
        },
      },
      animation: false,
    }
  }, null, 8, ["data", "options"]))
}
}

})